import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpSubmitExperienceVettingOptions,
	httpSubmitExperienceVetting
} from '@/features/experience-vetting/http/experience-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useSubmitExperienceVetting = (
	urlParams: HttpSubmitExperienceVettingOptions['urlParams'],
	options?: UseMutationOptions<
		unknown,
		unknown,
		HttpSubmitExperienceVettingOptions['payload']
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			httpSubmitExperienceVetting({
				urlParams,
				payload,
				params: {
					responseType: 'small'
				}
			}),
		onError: (error) => errorHandler(error),
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.EXPERIENCE_VETTING]
			})
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.EXPERIENCE_VETTING_VERSIONS]
			})
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
